import { render, staticRenderFns } from "./bookerFeatures.vue?vue&type=template&id=bf7102b0&scoped=true"
import script from "./bookerFeatures.vue?vue&type=script&lang=js"
export * from "./bookerFeatures.vue?vue&type=script&lang=js"
import style0 from "./bookerFeatures.vue?vue&type=style&index=0&id=bf7102b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7102b0",
  null
  
)

export default component.exports